import type { ReactNode } from 'react';

import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components/ui/tooltip';

/** Shows `text` on hover and on keyboard focus around its children; a disabled control still gets its reason because the wrapper takes focus. */
export function Hint({
    text,
    children,
    focusable = false,
    className,
}: {
    text: string | undefined;
    children: ReactNode;
    /** Makes the wrapper a tab stop; set it while the child is disabled so the reason stays reachable. */
    focusable?: boolean;
    className?: string;
}) {
    if (!text) return <>{children}</>;
    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        className={className ?? 'inline-flex'}
                        tabIndex={focusable ? 0 : undefined}
                        data-testid="Hint"
                    >
                        {children}
                    </span>
                </TooltipTrigger>
                <TooltipContent className="max-w-xs text-xs">{text}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
